import React from 'react';
import { Navigate } from 'react-router-dom';

// This page is deprecated - SessionSelectionPage now handles session selection
export default function RetreatDetailPage() {
  return <Navigate to="/sessions" replace />;
}
